import { getFeatureFlag } from 'src/app/core/services/feature-flag-helpers';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { TWhiteLabelPanelColors } from '../white-label.model';
import { DEFAULT_ORIGINAL_PANEL_COLORS, DEFAULT_PANEL_COLORS } from './white-label-defaults.const';

export function getDefaultPanelColors(): TWhiteLabelPanelColors {
  if (getFeatureFlag(EFeatureFlag.REBRAND)) {
    return DEFAULT_PANEL_COLORS;
  }

  return DEFAULT_ORIGINAL_PANEL_COLORS;
}
